<script>
	export let active;
	export let pars;
    import { dataset } from '../stores.js';
	import Template from '../components/Template.svelte';
	import * as animateScroll from "svelte-scrollto";
	import { afterUpdate } from 'svelte';

	const downloadPages = {
		'WHO_-_SCORE_2025_Global_Assessment_Report': {
			title: 'SCORE 2025 Global Assessment <strong>Summary Report</strong>',
			description: '',
			file: './uploads/WHO_-_SCORE_2025_Global_Assessment_Report.pdf',
			thumbnail: './uploads/WHO_-_SCORE_2025_Global_Assessment_Report.webp'
		},
		'WHO_-_SCORE_2025_Global_Assessment_Executive_Summary': {
			title: 'SCORE 2025 Global Assessment <strong>Executive Summary</strong>',
			description: '',
			file: './uploads/WHO_-_SCORE_2025_Global_Assessment_Executive_Summary.pdf',
			thumbnail: './uploads/WHO_-_SCORE_2025_Global_Assessment_Executive_Summary.webp'
		}
	};

	$: requestedDownload = pars && pars[1] ? downloadPages[pars[1]] : null;
	$: downloadList = Object.keys(downloadPages).map((slug) => ({
		slug,
		...downloadPages[slug]
	}));

	afterUpdate(() => {
		if(pars[1] && !requestedDownload){
			animateScroll.scrollTo({element: "#"+pars[1], offset: -100});
		}
	});

	function stripHtml(value) {
		return value ? value.replace(/<[^>]+>/g, '') : '';
	}

	function trackDownload(download) {
		if (!window.gtag || !download) return;

		window.gtag('event', 'file_download', {
			file_url: download.file,
			download_slug: download.slug,
			download_title: stripHtml(download.title),
			download_type: 'global_assessment'
		});
	}

</script>
<Template active={active}>
	{#if requestedDownload}
		<header class="downloads-header">
			<div class="container-fluid wrap big-card">
				<section class="row mb3 mt3 middle-xs tl">
					<div class="col-xs-12 col-sm-4 col-md-3 downloads-item">
						<figure class="cover">
							<img src={requestedDownload.thumbnail} alt={requestedDownload.title}>
						</figure>
					</div>
					<div class="col-xs-12 col-sm-7 col-md-6 tc tl-sm">
						<h2 class="downloads-item__title">{@html requestedDownload.title}</h2>
						<p class="downloads-item__description">{requestedDownload.description}</p>
						<div class="flex center-xs start-sm">
							<a
								href={requestedDownload.file}
								target="_blank"
								class="btn btn-primary"
								data-download={pars[1]}
								on:click={() => trackDownload({ slug: pars[1], ...requestedDownload })}
							>Download</a>
						</div>
					</div>
				</section>
			</div>
		</header>
	{:else}
	<header class="downloads-header">
	    <div class="container-fluid wrap big-card">
	        <section class="row">
				{#each downloadList as download}
					<article class="col-xs-12 col-sm-6 col-md-5 mb5">
						<div class="row mb3 mt3 middle-xs downloads-item">
							<div class="col-xs-5">
								<figure class="cover">
									<img src={download.thumbnail} alt={download.title}>
								</figure>
							</div>
							<div class="col-xs-7">
								<h4 class="downloads-item__title">{@html download.title}</h4>
								<p class="downloads-item__description">{download.description}</p>
								<div class="flex">
									<a
										href={download.file}
										target="_blank"
										class="btn btn-primary"
										data-download={download.slug}
										on:click={() => trackDownload(download)}
									>Download</a>
								</div>
							</div>
						</div>
					</article>
				{/each}
	        </section>
	    </div>
	</header>
	{/if}
</Template>
